import { useSetRecoilState } from 'recoil';
import { modalSelector } from '../stores/modal/selectors';

const useModal = () => {
  const setModal = useSetRecoilState(modalSelector);
  const open = ({
    content,
    onClose,
    shouldCloseOnOverlayClick = false,
  }) => {
    setModal({
      isOpen: true,
      content,
      onClose,
      shouldCloseOnOverlayClick,
    });
  };
  const close = (cb) => {
    setModal({
      isOpen: false,
      content: null,
      onClose: cb,
      shouldCloseOnOverlayClick: false,
    });
  };
  return {
    open,
    close,
  };
};

export default useModal;
